<template>
  <b-modal 
    id="modal-1"
    ref="modal"
    :title="title"
    @show="toggleModal"
    @hidden="resetModal"
    @ok="handleOk"
    :ok-title="btnTitle"
    hide-footer
    cancel-title="Отмена"
    cancel-variant="light"
    footer-class="justify-content-between"
  >
    <div v-if="variant && variant.questions && !isFinished">
      <h4 class="text-center mb-3 font-weight-bold" v-if="variant">Вопрос {{ currentQuestion + 1 }}/{{ variant.questions.length }}</h4>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form ref="form" @submit.stop.prevent="handleSubmit(submit)" :class="{ 'form-submitted': isSubmitted }">

          <p v-if="variant"><strong>{{ variant.questions[currentQuestion].question }}</strong></p>

          <div v-if="variant.questions[currentQuestion].text" class="bg-light-blue p-3 mb-3 escaped" v-html="variant.questions[currentQuestion].text"></div>

          <b-form-group
            label=""
            v-slot="{ ariaDescribedby }"
            v-if="answers"
          >
            <b-form-checkbox-group
              v-model="form.answer"
              :options="answers"
              :aria-describedby="ariaDescribedby"
              :disabled-field="disabledField"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>

          <p class="text-center text-danger" v-if="isSubmitted && !form.answer.length">Отметьте вариант ответа</p>

          <b-button type="submit" variant="success" size="lg" block v-if="!isAnswered">Ответить</b-button>
          <a v-else class="btn btn-success btn-block btn-lg" href="#" @click.prevent="nextQuestion()">Следующий вопрос</a>
        </b-form>
      </validation-observer>
      <b-button type="submit" variant="light" size="lg" block @click="hideModal" class="mt-2">
        Отмена
      </b-button>
    </div>
    <div v-else>
      <h4 class="text-center">Тест пройден</h4>
      <br>
      <b-button type="submit" variant="light" size="lg" block @click="hideModal" class="mt-2">
        Закрыть
      </b-button>
    </div>
    
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['variant', 'subject'],
  data () {
    return {
      form: {
        answer: []
      },
      currentQuestion: null,
      isAnswered: false,
      isSubmitted: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      studentAnswers: state => state.students.answers
    }),
    title () {
      if (this.subject && this.variant) {
        return this.subject.title + '. ' + this.variant.title
      }
    },
    btnTitle () {
      if (this.item) {
        return 'Сохранить'
      } else {
        return 'Создать'
      }
    },
    answers () {
      return this.variant.questions[this.currentQuestion].answers.map((answer, index) => {
        return { value: index + 1, text: answer, disabledState: !this.variant.questions[this.currentQuestion].answer.includes(index) }
      })
    },
    disabledField () {
      if (this.isAnswered) {
        return 'disabledState'
      } else {
        return 'disabled'
      }
    },
    isAnswerCorrect () {
      return this.variant.questions[this.currentQuestion].answer.filter((answer) => {
        return this.form.answer.includes(answer)
      })
    },
    isFinished () {
      if (this.currentQuestion >= this.variant.questions.length) {
        return true
      }
    }
  },
  methods: {
    getValidationState ({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    submit () {
      this.isSubmitted = true
      if (this.form.answer.length) {
        this.isAnswered = true

        window.scrollTo(0, 0)
        this.$store.dispatch('SAVE_ANSWER_TO_QUESTION', { subject: this.subject.slug, variant: this.variant.slug, question: this.currentQuestion + 1, answer: this.form.answer, isAnswerCorrect: this.isAnswerCorrect }).then((response) => {
          this.$emit('update')
        }, error => {
          console.log(error)
        })
      }
    },
    nextQuestion () {
      this.form.answer = []
      this.currentQuestion++
      this.isSubmitted = false
      this.isAnswered = false
    },
    resetModal () {
    },
    showModal () {
      this.$refs['modal'].show()
    },
    hideModal () {
      this.$refs['modal'].hide()
    },
    toggleModal () {
      this.resetModal()
      this.$store.dispatch('GET_STUDENT_ANSWERS', this.subject.slug).then(() => {
        this.$refs['modal'].show()

        if (this.studentAnswers && this.studentAnswers[this.variant.id]) {
          this.currentQuestion = this.studentAnswers[this.variant.id].currentQuestion
        } else {
          this.currentQuestion = 0
        }
      })
    },
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.currentQuestion = 0
  },
  created () {
  }
}
</script>